import { EndPointChanges } from '../../interfaces/endpoint-changes.interface';

/** Arrival changes describe the whole bound, so only the last flight's arrival announces them. */
export const getBoundArrivalNotification = (
  lastLeg: boolean,
  arrivalChanges: EndPointChanges | undefined,
  isCanceled = false
): string | undefined => (lastLeg && !isCanceled ? arrivalChanges?.notification : undefined);
